import GradesEditor from "@/components/GradesEditor";
export default function YearWorkGrades() {
  return <GradesEditor mode="year-work" />;
}
